module.exports = {
	methods: {
    	toggleHtmlClass(className, add = true) {
    		let htmlClasses = document.getElementsByTagName("html")[0].classList;

    		if(!add) {
    			htmlClasses.remove(className);
    		} else {
    			htmlClasses.add(className);
    		}
    	}
    }
}
